import React from 'react';
import { localeLabels, localeNames, supportedLocales } from '../i18n/locales';
import { useI18n } from '../i18n/I18nContext';

function LanguageLink({ locale, active, href, variant, compact, onClick }) {
  const color = variant === "dark" ? "text-white" : "text-dark";
  const activeClass = active ? "font-bold opacity-100" : "font-medium opacity-60 hover:opacity-100";
  const size = compact ? "text-base" : "text-lg";

  return (
    <a
      className={`${color} ${size} ${activeClass} uppercase transition duration-300`}
      href={href}
      aria-current={active ? "true" : undefined}
      aria-label={localeNames[locale]}
      onClick={onClick}
    >
      {localeLabels[locale]}
    </a>
  );
}

function LanguageMenu({ variant = "light", compact = false, onSelect }) {
  const { locale: currentLocale, alternatePathFor } = useI18n();
  const color = variant === "dark" ? "text-white" : "text-dark";

  return (
    <div className={`flex items-center gap-2 ${color}`} aria-label="Language">
      {supportedLocales.map((locale, index) => (
        <React.Fragment key={locale}>
          {index > 0 && <span className="text-sm opacity-40" aria-hidden="true">/</span>}
          <LanguageLink
            locale={locale}
            active={locale === currentLocale}
            href={alternatePathFor(locale)}
            variant={variant}
            compact={compact}
            onClick={onSelect}
          />
        </React.Fragment>
      ))}
    </div>
  );
}

export default LanguageMenu;
